export const CloseRedIcon: React.FC<React.SVGAttributes<{}>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_18364_36954)">
      <path
        d="M19.9997 38.2076C30.0506 38.2076 38.1985 30.0597 38.1985 20.0087C38.1985 9.95773 30.0506 1.80981 19.9997 1.80981C9.9487 1.80981 1.80078 9.95773 1.80078 20.0087C1.80078 30.0597 9.9487 38.2076 19.9997 38.2076Z"
        stroke="#F0567A"
        strokeWidth="3.60156"
        strokeMiterlimit="10"
      />
      <path
        d="M28.6775 11.4728L28.677 11.4723C27.9601 10.7554 26.7977 10.7554 26.0808 11.4723L11.5564 25.9967C10.8395 26.7136 10.8395 27.876 11.5564 28.593L11.5569 28.5935C12.2738 29.3104 13.4362 29.3104 14.1531 28.5935L28.6775 14.0691C29.3945 13.3521 29.3945 12.1897 28.6775 11.4728Z"
        fill="#F0567A"
      />
      <path
        d="M28.6779 28.5935L28.6784 28.5931C29.3954 27.8761 29.3954 26.7137 28.6784 25.9968L14.1541 11.4724C13.4371 10.7555 12.2747 10.7555 11.5578 11.4724L11.5573 11.4729C10.8404 12.1898 10.8404 13.3522 11.5573 14.0692L26.0817 28.5935C26.7986 29.3105 27.961 29.3105 28.6779 28.5935Z"
        fill="#F0567A"
      />
    </g>
    <defs>
      <clipPath id="clip0_18364_36954">
        <rect
          width="40"
          height="40"
          fill="white"
          transform="translate(0 0.0090332)"
        />
      </clipPath>
    </defs>
  </svg>
);
